export default __webpack_public_path__ + "static/media/hours_background.b7df4210.jpg";